import React, { useEffect } from "react";
import { Col, Row, Container, Button, Alert } from "react-bootstrap";
import GalleryItem from "./GalleryItem/GalleryItem";
import { useTranslation } from 'react-i18next';
import { FadeLoader } from 'react-spinners';

const Gallery = ({ mediaItems, isLoading, getMoreAssets, next }) => {
    const { t } = useTranslation();

    return (
        <Container fluid className={`panel panel-body d-flex align-items-center gallery ${mediaItems?.length !== 0 ? "flex-column" : ""}`}>
            {isLoading ? (
                <Container fluid style={{ "height": "120px" }} className="d-flex justify-content-center">
                    <FadeLoader
                        color="#1a6fb8"
                        height={25}
                        loading
                        margin={15}
                        radius={2}
                        speedMultiplier={1.5}
                        width={3}
                    />
                </Container>
            ) : (
                <>
                    {(mediaItems && mediaItems.length !== 0) ? (
                        <>
                            <Row xs={1} sm={2} md={3} lg={4} xl={5} className="g-3 w-100">
                                {mediaItems.map((item, index) => (
                                    <Col key={index}>
                                        <GalleryItem item={item} />
                                    </Col>
                                ))}
                            </Row>
                            {next && <Button variant="outline-secondary" className='more-btn w-100' onClick={getMoreAssets}>{t('more')}</Button>}
                        </>
                    ) : (
                        <Alert variant="info" className="w-100 h-100 m-0">{t('no_results')}</Alert>
                    )}
                </>
            )}
        </Container>
    );
};

export default Gallery;